var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKycSafeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.694,
    height: 24.537,
    viewBox: "0 0 21.694 24.537",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "noun-shield-5374151",
    d: "M148.126,36.732a17.626,17.626,0,0,0,6.97-5.425,12.33,12.33,0,0,0,2.231-7.431l0-5.412a19.117,19.117,0,0,1-4.923-.852,15.818,15.818,0,0,1-4.277-2.105,15.825,15.825,0,0,1-4.277,2.105,19.119,19.119,0,0,1-4.923.852v5.425a12.315,12.315,0,0,0,2.229,7.439,17.507,17.507,0,0,0,6.973,5.4Zm-4.679-10.857a.625.625,0,0,1,.112-.886.748.748,0,0,1,.979.1l2.28,2.594,4.893-5.567a.748.748,0,0,1,.979-.1.591.591,0,0,1,.112.886l-5.432,6.181a.665.665,0,0,1-.118.109.748.748,0,0,1-.979-.1l-2.424-2.8-.117-.164c-.754-.93-.082-.044-.284-.255Zm12.822,6.113a19.184,19.184,0,0,1-7.774,5.989.763.763,0,0,1-.688.028,19.1,19.1,0,0,1-7.829-6,13.47,13.47,0,0,1-2.449-8.12l0-6.032a.668.668,0,0,1,.688-.629,17.973,17.973,0,0,0,5.169-.805,14.371,14.371,0,0,0,4.291-2.2.753.753,0,0,1,.894,0,14.371,14.371,0,0,0,4.3,2.205,17.935,17.935,0,0,0,5.11.8h.049a.668.668,0,0,1,.7.632v6.018a13.483,13.483,0,0,1-2.452,8.112Z",
    transform: "translate(-137.276 -13.793)",
    fill: "#3f81f4",
    stroke: "#3f81f4",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKycSafeIcon);
export default __webpack_public_path__ + "static/media/kyc-safe-icon.24954be01ed45b8d4753f2cf533d10b8.svg";
export { ForwardRef as ReactComponent };